import FlexMainWrapper from '../../designComponents/wrappers/FlexMainWrapper';
import { SText } from '../../designComponents/text/ContentText';
import { FlexTwoText } from '../../designComponents/text/TextMapping';
import { getWelcomeGiftDisplay } from './welcomeGiftAdmin';

const labelStyle = {fontSize: '14px', fontWeight: '400', width: '160px', textAlign: 'start'};
const valueStyle = {fontWeight: '500', fontSize: '14px'};

const WelcomeGiftInfo = ({data}) => {
    const display = getWelcomeGiftDisplay(data);
    const rows = [
        ['웰컴기프트 대상 여부', display.eligible],
        ['선택 혜택', display.benefit],
        ['선택 일시', display.selected_at],
        ['진행 상태', display.status],
    ];

    return (
        <FlexMainWrapper style={{flexDirection: 'column', alignItems: 'start', width: '100%', marginTop: '20px'}}>
            <SText text={'웰컴기프트 정보'} style={{fontWeight: '600', marginBottom: '5px'}} />
            {rows.map(([label, value]) => (
                <FlexTwoText
                    key={label}
                    wrapperStyle={{margin: '5px 0'}}
                    text01={label}
                    text01Style={labelStyle}
                    text02={value}
                    text02Style={valueStyle}
                />
            ))}
        </FlexMainWrapper>
    );
};

export default WelcomeGiftInfo;
